import { BaseAction } from "../../../core/actions/BaseAction";
import { IDefaultActionResult } from '../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult';
import { getTripDetailsFromBookingAction } from '../../LogicActions/BookItAgain/GetTripDetailsFromBookingAction';
import { getBookingAction } from '../../LogicActions/Booking/GetBookingAction';
import { IBookingResponse } from '../../../Orchestrator/Types/Types/BookingTypes';
import { getBooking } from '../../../app/api/getBooking';

export class BookItAgainUpcomingPastClickAction extends BaseAction<IDefaultActionResult, string> {

    override async run(): Promise<IDefaultActionResult> {
        let result: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        try {
            const bookingId = this.params!
            if (bookingId) {
                const response: any = await getBooking(bookingId);
                if (response.status === 'ok' && response.answer) {
                    const bookingResponse: IBookingResponse = response.answer;
                    const { booking } = bookingResponse;
                    getTripDetailsFromBookingAction.setParams({
                        booking: booking,
                    });
                    getTripDetailsFromBookingAction.execute();
                }
            }
        } catch (error) {
            result.message = "something went wrong"
        } finally {
            return result;
        }
    }
}

export const bookItAgainUpcomingPastClickAction = new BookItAgainUpcomingPastClickAction(); 